import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { InsuranceDTO } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';

export interface InsuranceRequest {
  organizationId: string | undefined;
  patientId?: string | undefined;
  onlyAvailable?: boolean;
}

const useGetInsuranceConfiguration = ({
  organizationId,
  patientId,
  onlyAvailable,
}: InsuranceRequest) => {
  const baseUrl = useApiUrl(
    OBRoutes.InsuranceConfig,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##organizationId', organizationId || '');

  const queryParams = new URLSearchParams({
    ...(patientId ? { patientId } : {}),
    onlyAvailable: onlyAvailable ? 'true' : 'false',
  });
  const url = queryParams.size ? `${baseUrl}?${queryParams}` : baseUrl;

  return useOBQuery<InsuranceDTO>(url, {
    enabled: !!url && !!organizationId,
    staleTime: 600000,
  });
};

export default useGetInsuranceConfiguration;
